module.exports = __webpack_public_path__ + "static/profile-pic-aa298706b1b24bf3be6b284cf8644cbd.png";